import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch as MuiSwitch,
} from "@mui/material";
import PropTypes from "prop-types";
import { convertToDefEventPara } from "../helper.js";

Switch.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function Switch(props) {
  const {
    item,
    value = false,
    onChange,
    error,
    showErrorText = false,
    disabled = false,
  } = props;

  let helperText = "";
  if (showErrorText) {
    helperText = error;
  } else if (item.help) {
    helperText = item.help;
  }

  return (
    <FormControl {...(error && { error: true })} size="medium">
      <FormControlLabel
        sx={{ ml: 0, gap: "1rem" }}
        control={
          <MuiSwitch
            name={item.name}
            checked={Boolean(value) || false}
            disabled={disabled}
            onChange={(e) =>
              onChange(convertToDefEventPara(item.name, e.target.checked))
            }
          />
        }
        label={item.label}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
